export const VAULTFETCHINGSUMMARY = 'VAULTFETCHINGSUMMARY'
export const VAULTFETCHINGSUMMARYDONE = 'VAULTFETCHINGSUMMARYDONE'

export const VAULTDRAFTDOCUMENTSSADDED = 'VAULTDRAFTDOCUMENTSSADDED'
export const VAULTUPDATEPROGRESS = 'VAULTUPDATEPROGRESS'
export const VAULTUPDATEDRAFTDOCUMENT = 'VAULTUPDATEDRAFTDOCUMENT'
export const VAULTUPDATEUPLOADINGSTATUS = 'VAULTUPDATEUPLOADINGSTATUS'
export const VAULTREMOVEDRAFTDOCUMENT = 'VAULTREMOVEDRAFTDOCUMENT'
export const VAULTFILESUPLOADED = 'VAULTFILESUPLOADED'
export const VAULTDRAFTDOCUMENTSRESET = 'VAULTDRAFTDOCUMENTSRESET'
export const VAULTREMOVEDRAFTBO = 'VAULTREMOVEDRAFTBO'
export const VAULTDRAFTBOADDED = 'VAULTDRAFTBOADDED'
export const VAULTRESETDRAFTBO = 'VAULTRESETDRAFTBO'

export const VAULTOPTVERIFYSTARTED = 'VAULTOPTVERIFYSTARTED'
export const VAULTOTPVERIFYDONE = 'VAULTOTPVERIFYDONE'
export const VAULTOTPVERIFYFAILED = 'VAULTOTPVERIFYFAILED'
export const VAULTVERITYRESET = 'VAULTVERITYRESET'

export const VAULTFETCHINGDOCUMENTS = 'VAULTFETCHINGDOCUMENTS'
export const VAULTFETCHINGDOCUMENTSDONE = 'VAULTFETCHINGDOCUMENTSDONE'
export const VAULTREMOVINGDOCUMENTS = 'VAULTFETCHINGDOCUMENTS'
export const VAULTREMOVINGDOCUMENTSDONE = 'VAULTFETCHINGDOCUMENTSDONE'
export const VAULTSUBMITTINGDRAFTDOCUMENTS = 'VAULTSUBMITTINGDRAFTDOCUMENTS'
export const VAULTSUBMITTINGDRAFTDOCUMENTSDONE = 'VAULTSUBMITTINGDRAFTDOCUMENTSDONE'
export const VAULTCLEARSTAUS = 'VAULTCLEARSTAUS'

export const VAULTFETCHINGBOS = 'VAULTFETCHINGBOS'
export const VAULTFETCHINGBOSDONE = 'VAULTFETCHINGBOSDONE'
export const VAULTREMOVINGBOS = 'VAULTREMOVINGBOS'
export const VAULTREMOVINGBOSDONE = 'VAULTREMOVINGBOSDONE'
export const VAULTSUBMITTINGDRAFTBOS = 'VAULTSUBMITTINGDRAFTBOS'
export const VAULTSUBMITTINGDRAFTBOSDONE = 'VAULTSUBMITTINGDRAFTBOSDONE'

export const VAULTUPDATEDOCS = 'VAULTUPDATEDOCS'
export const UPDATEBOS = 'UPDATEBOS'
